import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Wrapper = styled.div `
  --background: ${brand.primary.white};
  &[data-theme='light-blue'] {
    --background: ${brand.secondary.paleBlue};
  }

  background-color: var(--background);
`;
const Container = styled.ul `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  row-gap: 12px;
  min-height: 70px;

  ${siteWide}
  padding-top: 15px;
  padding-bottom: 15px;
  max-width: 1920px;
`;
const NavItem = styled.li `
  ${fonts.ubuntu.regular};
  color: ${brand.primary.darkBlue};
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 16px;

  a {
    text-decoration: none;
    color: ${brand.primary.darkBlue};
  }

  svg {
    width: 12px;
    height: 12px;
    color: ${brand.primary.brightBlue};
    margin-top: 1px;
  }
`;
export const BreadcrumbsStyles = {
    Container,
    NavItem,
    Wrapper,
};
